<template>
    <Modal :id="id" title="Send Email">
        <div slot="body" class="modal-body" v-if="event">
            <template v-if="hasRegisteredStudents">
                <div class="col-12">
                    <transition name="fade">
                        <Alert v-if="hasAlert" :alert="alert" />
                    </transition>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <Field type="text" validate="required" name="subject" label="Subject" v-model="form.subject"/>
                        </div>
                        <div class="col-12 mb-3">
                            <Field type="textarea" validate="required" name="message" label="Message" v-model="form.message"/>
                        </div>
                        <div class="col-12 mb-3" v-if="event.status === $root.constants.CLOSED_EVENT">
                            <Field
                                type="checkbox"
                                name="attended_only"
                                id="cb-attended_only"
                                label="Send only to students who attended the event"
                                v-model="form.attended_only"
                            />
                        </div>

                        <div class="col-12 mb-3">
                            <div class="element has-label">
                                <label>
                                    Attach a File (max filesize: 2MB)
                                </label>
                                <p class="text-secondary small">
                                    Supported file types include documents (PDF, Word, Excel, Rich/Plain Text) and images (JPG, GIF, PNG)
                                </p>
                                <FileUpload
                                    @uploaded="updateUploadedFile"
                                    id="email-roster-attachment"
                                    :url="route('training.events.email-roster.attachment', routeParam)"
                                />
                            </div>
                        </div>

                        <div class="col-12 mb-3">
                            <div class="mb-3">
                                <a href="#" class="small" @click.prevent="showRecipients = !showRecipients">
                                    {{ showRecipients ? '- Hide' : '+ Show' }} Recipients ({{ emailRecipients.length }})
                                </a>
                            </div>

                            <div class="alert alert-info" v-if="showRecipients">
                                <p>This message will be sent to the following recipients:</p>
                                <ul id="email-recipients" class="mb-3">
                                    <li v-for="recipient in emailRecipients" :key="recipient.id">
                                        {{ recipient.name }} ({{ recipient.email }})
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="alert alert-danger" v-else>
                There are no students currently registered for this event.
            </div>
        </div>

        <div slot="footer" class="modal-footer">
            <a
                href="#"
                class="btn btn-info"
                :class="{disabled: sending}"
                @click.prevent="send()"
                :disabled="sending"
            >
                {{ sending ? 'Sending...' : 'Send' }}
            </a>
            <a
                href="#"
                class="btn btn-secondary"
                :class="{disabled: sending}"
                @click.prevent="close()"
            >
                Close
            </a>
        </div>
    </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import DisplaysAlerts from "mixins/DisplaysAlerts";
import HtmlField from 'components/forms/HtmlField'
import FileUpload from 'components/forms/FileUpload'

export default {
    components: {FileUpload, HtmlField},
    mixins: [ModalMixin, DisplaysAlerts],
    data() {
        return {
            id: "email-roster-modal",
            event: null,
            showRecipients: false,
            sending: false,
            form: {
                subject: "",
                message: "",
                attended_only: false,
                attachment: null,
            },
        };
    },

    computed: {
        routeParam() {
            return {event: this.event.id};
        },

        hasRegisteredStudents() {
            return this.validEnrollments.length > 0
        },

        validEnrollments() {
            return this.event
                .enrollments
                .filter(e => e.enrollment_status === this.$root.constants.ENROLLMENT_ENROLLED);
        },

        emailRecipients() {
            let enrollments = this.validEnrollments;

            if (this.attended_only) {
                enrollments = this.validEnrollments
                    .filter(enrollment => {
                        return enrollment.completion_status === this.$root.constants.COMPLETION_PASSED;
                    })
            }

            return enrollments.map(enrollment => enrollment.user)
        },

        defaultSubject() {
            const userType = this.$root.user.id === this.event.contact_id ? 'local contact' : 'trainer';
            const eventStartDate = this.$moment(this.event.start_date).format('MM/DD/YYYY')

            return `A message from the ${userType} - ${this.event.name} (${eventStartDate})`;
        }
    },

    methods: {
        send() {
            if (this.sending) return;

            this.hideAlert();
            this.sending = true;

            this.axios
                .post(this.route('training.events.email-roster', this.routeParam), this.form)
                .then(response => {
                    this.sending = false;
                    this.showAlert("success", "Emails sent successfully.");
                })
                .catch(({ response }) => {
                    this.sending = false;

                    if (response.status === 422) {
                        this.parseErrors(e.response.data.errors);
                        this.alertTextAlign = "left";
                        return;
                    }

                    this.showAlert("danger", e.response.data.message);
                });
        },

        updateUploadedFile(file, response) {
            this.form.attachment = response.file;
        },
    },

    mounted() {
        this.event = _.cloneDeep(this.options.event);
        this.form.subject = this.defaultSubject;
    },
};
</script>
